import React from "react";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark,faBookOpen,faBook } from "@fortawesome/free-solid-svg-icons";
import "./blogs.css";

function BlogSidebar({ blogs,closeSidebar,active }) {
    return (
        <div>
          <div className="blogs-sidebar-heading">
            <h5 className="mb-3">Blogs</h5>
            <FontAwesomeIcon className={"blogs-sidebar-close-icon"}icon={faXmark} onClick={closeSidebar}/>
          </div>
          <Nav className="flex-column">
            {blogs && blogs.map((b) => (
              <Nav.Item key={b.id} className="blog-sidebar-topic">         
                { active === b.path ? (<FontAwesomeIcon className={`blog-sidebar-topic-icon ${active === b.path ? "nav-link-active":"blog-nav-link"}`} icon={faBookOpen} />)
                :
                (<FontAwesomeIcon className={`blog-sidebar-topic-icon ${active === b.path ? "nav-link-active":"blog-nav-link"}`} icon={faBook} />)}       
                <Link to={`/blogs/${b.path}`} className={active === b.path ? "nav-link-active":"blog-nav-link"} onClick={closeSidebar}>
                  {b.title} - {b.published}
                </Link>
              </Nav.Item>
            ))}
          </Nav>
        </div>
      );
}

export default BlogSidebar;
